import React, { Children, ReactElement, useEffect, useRef } from 'react';
import Pill from './Pill';
import navStore from './navStore';
import Link, { ILink } from './Link';
export { Link };

type IConfig = {
  linkWidth: number;
  scrollTimeout: number;
  stickyScroll?: boolean;
};

interface INav {
  children: ReactElement<ILink>[];
  config: IConfig;
}

const Nav = ({ children, config }: INav) => {
  const setVisibleSections = navStore(state => state.setVisibleSections);
  const setConfig = navStore(state => state.setConfig);

  useEffect(() => {
    setConfig(config);
  }, [config, setConfig]);

  const observers = useRef<any>([]);
  useEffect(() => {
    Children.forEach(children, child => {
      if (observers.current.length < children.length)
        observers.current = [
          ...observers.current,
          new IntersectionObserver(entries =>
            entries.forEach(e => {
              setVisibleSections(
                parseInt(e.target.id.slice(-1)),
                e.isIntersecting
              );
            })
          ),
        ];

      observers.current.forEach(o =>
        o.observe(
          document.querySelector(`[id="${child.props.href.substring(1)}"]`)
        )
      );
    });
  }, [children, setVisibleSections]);
  return <Pill>{children}</Pill>;
};

export default Nav;
